import React, { FC } from 'react'

import { GradientBackgroundScreen, Metadata, Card } from '@components'

import { SignInScreenContent } from './SignInScreenContent'

export const SignInScreen: FC = () => {
  return (
    <>
      <Metadata title='Sign In' />

      <GradientBackgroundScreen>
        <Card variant='authCard'>
          <SignInScreenContent />
        </Card>
      </GradientBackgroundScreen>
    </>
  )
}

export default SignInScreen
